var OrganizationHierarchicalNode;

import {
  select_node_mixins,
  node_change_mixins
} from './mixins.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import CreateOrganizationModal from 'trunks/vue/admin/compositions/organizations/responses/create_organization_modal.js';

export default OrganizationHierarchicalNode = Vue.extend({
  mixins: [select_node_mixins, node_change_mixins],
  name: 'hierarchical-select-node',
  components: {
    'Popover': Popover
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    selectedOrganizationId: {
      type: Number
    },
    initialSelectedNodeAncestry: {
      type: Array
    },
    profileSchema: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      expanded: false,
      showPopover: false
    };
  },
  computed: {
    level: function() {
      return this.node.path.length;
    },
    // class objects
    nodeClass: function() {
      return {
        expanded: this.expanded
      };
    },
    toggleClass: function() {
      if (this.node.isLeaf) {
        return {
          'slp-empty': true
        };
      } else {
        return {
          'slp-chevron-right': !this.expanded,
          'slp-chevron-down': this.expanded
        };
      }
    },
    selected: function() {
      return this.node.id === this.selectedOrganizationId;
    },
    paddingLeft: function() {
      return (this.level - 1) * 1 + 'rem';
    },
    nodeHover: function() {
      return !this.showPopover;
    },
    nodeShow: function() {
      return this.showPopover;
    }
  },
  template: `<div class='hierarchical-select-node' :class='nodeClass' >
  <div class='node-wrapper justify-between'
       :class="{selected: selected}"
       @click.stop='selectNode'>
    <div class='content node-name text-ellipsis'
         :style="{ paddingLeft: paddingLeft }">
      <i :class='toggleClass' @click.stop='toggleExpand'></i>
      <span>{{ node.name }}</span>
    </div>
    <Popover position='bottom right'
             size="small"
             @beforeOpen="popoverBeforeOpen"
             @beforeClose="popoverBeforeClose"
             ref="popoverRef">
      <template slot="trigger">
        <div :class='{"node-hover": nodeHover , "node-show": nodeShow}'
             @click.stop="togglePopover">
          <i class="slp-ellipsis-circle-o"></i>
        </div>
      </template>
      <div class="list" slot="content">
        <div class="list-item" @click.stop="editOrganizationName">
          <i class="slp-pencil"></i>
          <span class="ml-2">修改组织名称</span>
        </div>
        <div class="list-item" @click.stop="openCreateOrganizationModal">
          <i class="slp-plus-circle-o"></i>
          <span class="ml-2">新增下级组织</span>
        </div>
        <div class="list-item" @click.stop="moveOrganization">
          <i class="slp-move"></i>
          <span class="ml-2">移动组织</span>
        </div>
        <div class="list-item" @click.stop="deleteOrganization">
          <i class="slp-trash"></i>
          <span class="ml-2">删除组织</span>
        </div>
      </div>
    </Popover>
  </div>
  <div class='node-children'>
    <hierarchical-select-node
      v-for='child in node.children'
      :key='child.id'
      :node='child'
      :selectedOrganizationId='selectedOrganizationId'
      :initialSelectedNodeAncestry='initialSelectedNodeAncestry'
      :profileSchema='profileSchema'
      @organizationDeleted='onOrganizationDeleted'
      @organizationSelected='onOrganizationSelected'
      ref='children'/>
  </div>
</div>`,
  created: function() {
    return this._initExpanded();
  },
  methods: {
    selectNode: function() {
      return this.$emit('organizationSelected', this.node);
    },
    popoverBeforeOpen: function() {
      return this.showPopover = true;
    },
    popoverBeforeClose: function() {
      return this.showPopover = false;
    },
    togglePopover: function(event) {
      return this.$refs.popoverRef.togglePopover();
    },
    toggleExpand: function() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        return this._fetchChildren();
      }
    },
    openCreateOrganizationModal: function() {
      this.createOrganizationModal = new CreateOrganizationModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('create_organization_modal_container'),
        propsData: {
          parent: this.node,
          profileSchema: this.profileSchema,
          childrenAddCallback: () => {
            this.node.children_count += 1;
            return this._fetchChildren();
          }
        }
      });
      return this.$refs.popoverRef.close();
    },
    _fetchChildren: function() {
      if (this.node.children_count === this.node.children.length) {
        return;
      }
      return Skylark.Libs.Ajax.get(`${this.node.hierarchy.resources}/${this.node.id}/children`, {
        responseType: 'json',
        success: (rawNodes) => {
          // reset(correct) children_count if children are blank
          if (_.isBlank(rawNodes)) {
            return this.node.children_count = 0;
          } else {
            this.node.children_count = rawNodes.length;
            return this.node.hierarchy.addNodes(rawNodes);
          }
        }
      });
    },
    _initExpanded: function() {
      if (_.contains(this.initialSelectedNodeAncestry, this.node.id)) {
        return this.toggleExpand();
      }
    }
  }
});
